import { render, staticRenderFns } from "./SuppliesReport.vue?vue&type=template&id=5c1f29fa&"
import script from "./SuppliesReport.vue?vue&type=script&lang=js&"
export * from "./SuppliesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports